import React, { useState } from "react";

import styled from "styled-components";
import ChevronButton from "../../core/Button/ChevronButton";

export const Explanation = ({ target }) => {
  const [isOpen, setOpen] = useState(false);
  return (
    <ExplanationWrapper>
      <TitleSection>
        <Title>{target.title}</Title>
        {/* <Subtitle>({target.subtitle})</Subtitle> */}
        {/* <button
          className="close-button"
          onClick={() => {
            setOpen(!isOpen);
          }}
        >
          <ChevronButton isOpen={isOpen} />
        </button> */}
      </TitleSection>
      {/* {isOpen && <Content>{target.content}</Content>} */}
    </ExplanationWrapper>
  );
};

export default Explanation;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  padding: 1rem 0 2rem 0;
  gap: 1rem;

  box-sizing: border-box;
  margin: 0 auto;
  width: 80rem;
  max-width: 100%;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  margin-top: 1rem;
  text-align: center;
`;

const Subtitle = styled.h2`
  height: 3rem;
  font-size: 1.7rem;
  font-weight: 600;
  margin: 1rem 0;
  text-align: center;
`;

const Content = styled.p`
  font-size: 1.4rem;
  font-weight: 300;
  /* width: 8rem; */
  text-align: justify;
  text-justify: distribute;
  text-indent: 1rem;
  line-height: 2rem;
`;

const TitleSection = styled.section`
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  gap: 1rem;
  box-sizing: border-box;
  .close-button {
    all: unset;
    width: 2rem;
    height: 2rem;
    padding-top: 1rem;
    cursor: pointer;
    > img {
      width: 100%;
      height: 100%;
      filter: invert(1);
    }
  }
`;
